import React from 'react'
import numeral from 'numeral'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'

import { getFundsList } from '../selectors/funds.js'
import { fetchingState } from '../helpers/hocs.js'
import { getTotal, getFunds } from '../store/reducers/funds/list.js'

import Link from './../components/Link'
import Button from './../components/Button'

const Funds = ({ items = [], total = 0, length = 0, fetching, loadMore }) => {
  console.log('items!!!',items)
  return (
  <div className='Founds'>
    <div className='Container Container_light'>
      <div className='Founds__header'>
        Фонды, которым помогает наш проект совместно с ответственными брендами и неравнодушными людьми
      </div>
      <span className="Founds__table">
      {items.map((fund, i) => {
		//при наличие alias будет включен в ссылку на лот, если нет остается id
		let alias = fund._id
		if(fund.alias)
        {
          alias = fund.alias
        }
        return (
        
        <Link key={i} className='Link Link_light Founds__Link' to={'/funds/' + alias}> {/*Link_single */}
          <span className='Head Founds__head'>{ fund.name }</span>
          {<span className='Text Founds__total nobr' > {/*fund.sum && <span className='Text Founds__total nobr'>  style="display: table-cell"*/}
            {(numeral(fund.sumOfExternalPayments).format('0,0') == 0) ? <span>&nbsp;</span> : (numeral(fund.sumOfExternalPayments).format('0,0') + ' ₽')}
          </span>}
        </Link>
        
      )})}
      </span>
      { ((total - items.length) > 0) && (<Button loading={fetching} onClick={loadMore}>
        Посмотреть еще
      </Button>)}
      <div className="Home__row-small">
        Сумма, собранная в рамках кампаний, направленных на поддержку благотворительных фондов,
        социально-ориентированных  и иных некоммерческих организаций
      </div>
    </div>
  </div>
)}

const mapStateToProps = state => ({
  ...getFundsList(state),
  currentLocale: state.intl.locale
})

const mapDispatchToProps = dispatch => bindActionCreators({ getTotal, getFunds }, dispatch)
const mergeProps = (state, { getFunds, getTotal }, { fetchingWrap, ...props }) => ({
  ...props,
  ...state,
  getTotal,
  getFunds: (part, noLoader) => noLoader ? getFunds(part) : fetchingWrap(getFunds.bind(this, part))//part instead offset
})

// TODO: Добавить лоадер
export default compose(
  fetchingState(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    loadMore: ({ length = 0, getFunds, fetching }) => async e => {
      e && e.preventDefault()
      if (fetching) return
      await getFunds(length)
    }
  }),
  lifecycle({
    componentDidMount () {
      this.props.getFunds(0, false)
      this.props.getTotal()
    }
  })
)(Funds)



// WEBPACK FOOTER //
// ./src/containers/Funds.jsx